import {inlineError} from '@s-ui/decorators'

import {DraftRepository} from './DraftRepository.js'

export class CookieDraftRepository extends DraftRepository {
  constructor({config, cookie, draftEntityFactory, ongoingDraftResponseFactory, successResponseDraftVOFactory}) {
    super()

    this._config = config
    this._cookie = cookie
    this._draftEntityFactory = draftEntityFactory
    this._ongoingDraftResponseFactory = ongoingDraftResponseFactory
    this._successResponseDraftVOFactory = successResponseDraftVOFactory

    this._SECURE_COOKIES = this._config.get('SECURE_COOKIES')
    this._defaultAnonymousDraft = this._config.get('adPublisher').defaultAnonymousDraft

    const {COOKIES, COOKIE_EXPIRATIONS} = this._config.get('COMMON')
    this._ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY = COOKIES.ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY
    this._COOKIE_EXPIRATIONS = COOKIE_EXPIRATIONS
  }

  @inlineError
  saveAnonymousDraft({anonymousDraft}) {
    const cookie = this._config.get('cookie')

    cookie[this._ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY] = JSON.stringify({...anonymousDraft})

    this._cookie.set(
      this._ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY,
      {...anonymousDraft},
      {
        expires: this._COOKIE_EXPIRATIONS.ONE_YEAR,
        secure: this._SECURE_COOKIES
      }
    )

    return this._successResponseDraftVOFactory()
  }

  @inlineError
  discardAnonymousDraft() {
    this._cookie.remove(this._ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY)

    return this._successResponseDraftVOFactory()
  }

  @inlineError
  async getAnonymousDraft() {
    const cookieAnonymousDraft = this._config.get('cookie')[this._ANOMYMOUS_SELLER_DRAFT_COOKIE_KEY]

    let anonymousDraft
    let draftStatus = 200

    if (!cookieAnonymousDraft) {
      anonymousDraft = {...this._defaultAnonymousDraft}
      draftStatus = 201
      this.saveAnonymousDraft({anonymousDraft})
    } else {
      anonymousDraft = JSON.parse(cookieAnonymousDraft)
    }

    const draftEntity = this._draftEntityFactory(anonymousDraft)

    return this._ongoingDraftResponseFactory({
      status: draftStatus,
      draftEntity
    })
  }
}
